module.exports = __webpack_public_path__ + "img/banner_cfr_arms.de393fb0.png";